export const GOALS = {
  FULL: 'access-computer',
  EARLY: 'emerging-access',
  LOW: 'low-tech',
  NOTSURE: 'not-sure'
};
